
import ArrowBackIcon from '@material-ui/icons/ArrowBack'


import PortalModal, { usePortalModal } from 'components/commons/PortalModal'

import homeIcon from 'images/components/reporter/HomeIcon.svg'

import previewQuestionnaireStyles from './styles'
import { useHistory } from 'react-router-dom'

import Imagem from './assets/image/Woman thinking-cuate.png'
import {
   Button,
   Paper,
} from '@material-ui/core'
function FailQues({ score }) {
   const classes = previewQuestionnaireStyles()
   const history = useHistory()

 const goToMundoBack = () => {
  history.push('/dashboard/mutual-world?show=true')
}
  return (
     <div className={classes.container}>
        <Paper className={classes.paper}>
        <div className={classes.boxLineDecoration}>
               <div style={{ backgroundColor: '#71BE4A', width: '10%' }} />
               <div style={{ backgroundColor: '#0098DF', width: '10%' }} />
            </div>
            <h2 style={{marginTop: '40px'}} className={classes.titleResults}>¡Upps!</h2>
            <p  className={classes.subtitleResults}>TUS PUNTOS</p>
            <h2  className={classes.titleResults}>{score.score}</h2>
            <img className={classes.imgResults} src={Imagem} />
            <p className={classes.textResults}>No has obtenido la nota mínima para aprobar el cuestionario, inténtalo nuevamente.</p>
            <Button
               className={classes.buttonReadyAnswer}
               size="large"
               variant="contained"
               color="primary"
               style={{marginBottom: '40px'}}
               onClick={() => goToMundoBack()}
               >
                  VOLVER
            </Button>
        </Paper>
     </div>
  )
}

export default FailQues
